import { handleActions, combineActions } from 'redux-actions';
import { LOAD_USER_LOGIN_SSO } from '../constants';

const intialState = {
  loading: false,
  model: null,
  error: false,
  sentPin: false,
};

const userLogInSSOReducer = handleActions(
  {
    [LOAD_USER_LOGIN_SSO.PENDING]: state => ({
      ...state,
      loading: true,
      error: false,
      sentPin: false,
    }),
    [combineActions(
      LOAD_USER_LOGIN_SSO.CANCELLED,
      LOAD_USER_LOGIN_SSO.SUCCESS,
      LOAD_USER_LOGIN_SSO.ERROR,
      LOAD_USER_LOGIN_SSO.SENT,
    )]: state => ({
      ...state,
      loading: false,
    }),
    [LOAD_USER_LOGIN_SSO.SUCCESS]: (state, { payload }) => ({
      ...state,
      model: payload || state.model,
      error: false,
    }),
    [LOAD_USER_LOGIN_SSO.SENT]: (state, { payload }) => ({
      ...state,
      sentPin: payload || state.model,
      error: false,
    }),
    [LOAD_USER_LOGIN_SSO.ERROR]: (state, { payload }) => ({
      ...state,
      error: payload || state.model,
    }),
    [LOAD_USER_LOGIN_SSO.CLEAR]: () => intialState,
  },
  intialState,
);

export default userLogInSSOReducer;
